import { Pipe, PipeTransform } from '@angular/core';
import { AddressSuiteTypeList, MatterEVLStatus, VisaCategoryList, VisaTypeList } from '../../api/enum';
import { ActionModeList } from '../../api/enum/action-mode';
import { ActionStatusList } from '../../api/enum/action-status';
import { ActionTypeList } from '../../api/enum/action-type';
import { ActiveStatusList } from '../../api/enum/active-status';
import { AddressTypeList } from '../../api/enum/address-type';
import { TaskStatusList } from '../../api/enum/task-status';
import { TaskTypeList } from '../../api/enum/task-type';
import { CompanyAddressTypeList } from '../../api/enum/company-address-type';
import { CompanyContactRoleList } from '../../api/enum/company-contact-role';
import { CompanyTypeList } from '../../api/enum/company-type';
import { CompanyPartnerTypeList } from '../../api/enum/company-partner-type';
import { EntityTypeList } from '../../api/enum/entity-type';
import { FNDocumentTypeList } from '../../api/enum/fn-document-type';
import { FNEducationList } from '../../api/enum/fn-education';
import { ImmigrantStatusList } from '../../api/enum/immigrant-status';
import { MatterReceiptStatusList } from '../../api/enum/matter-receipt-status';
import { MatterReceiptShipMethodList } from '../../api/enum/matter-receipt-ship-method';
import { MatterReceiptTypeList } from '../../api/enum/matter-receipt-type';
import { MatterStatusList } from '../../api/enum/matter-status';
import { MatterProcessStepStatusList } from '../../api/enum/matter-process-step-status';
import { MilestoneStatusList } from '../../api/enum/milestone-status';
import { PhaseStatusList } from '../../api/enum/phase-status';
import { QuestionnaireStatusList } from '../../api/enum/questionnaire-status';
import { RelationshipTypeList } from '../../api/enum/relationship-type';
import { ReminderFrequencyList } from '../../api/enum/task-reminder-frequency';
import { StepStatusList } from '../../api/enum/step-status';
import { MatterEVLStatusList } from '../../api/enum/matter-evl-status';
import { MatterDocRequestStatusList } from '../../api/enum/document-request-status';
import { AudienceList } from '../../api/enum/audience';
import { SponsorTypeList } from '../../api/enum/sponsor-type';
import { AlertTypeList } from '../../api/enum/alert-type';

@Pipe({
  name: 'enum',
  standalone: true,
})
export class EnumPipe implements PipeTransform {
  transform(
    value: number,
    type:
      | 'ActionMode'
      | 'ActionStatus'
      | 'ActionType'
      | 'PhaseStatus'
      | 'MilestoneStatus'
      | 'MatterStatus'
      | 'StepStatus'
      | 'TaskStatus'
      | 'TaskType'
      | 'ReminderFrequency'
      | 'EntityType'
      | 'RelationshipType'
      | 'MatterStepStatus'
      | 'Audience'
      | 'QuestionnaireStatus'
      | 'CompanyAddressType'
      | 'ImmigrantStatus'
      | 'FNEducation'
      | 'CompanyContactRole'
      | 'PartnerCompanyType'
      | 'MatterReceiptStatus'
      | 'MatterReceiptShipMethod'
      | 'MatterReceiptType'
      | 'FNDocumentType'
      | 'CompanyType'
      | 'AddressSuiteType'
      | 'AddressType'
      | 'VisaType'
      | 'VisaCategory'
      | 'ActiveStatus'
      | 'MatterEVLStatus'
      | 'MatterDocRequestStatus'
      | 'SponsorType'
      | 'AlertType'
  ): string {
    switch (type) {
      case 'ActionMode':
        return ActionModeList.find((x) => x.value === value)?.label ?? '';
      case 'ActionStatus':
        return ActionStatusList.find((x) => x.value === value)?.label ?? '';
      case 'ActionType':
        return ActionTypeList.find((x) => x.value === value)?.label ?? '';
      case 'PhaseStatus':
        return PhaseStatusList.find((x) => x.value === value)?.label ?? '';
      case 'MilestoneStatus':
        return MilestoneStatusList.find((x) => x.value === value)?.label ?? '';
      case 'MatterStatus':
        return MatterStatusList.find((x) => x.value === value)?.label ?? '';
      case 'StepStatus':
        return StepStatusList.find((x) => x.value === value)?.label ?? '';
      case 'TaskStatus':
        return TaskStatusList.find((x) => x.value === value)?.label ?? '';
      case 'TaskType':
        return TaskTypeList.find((x) => x.value === value)?.label ?? '';
      case 'ReminderFrequency':
        return ReminderFrequencyList.find((x) => x.value === value)?.label ?? '';
      case 'EntityType':
        return EntityTypeList.find((x) => x.value === value)?.label ?? '';
      case 'RelationshipType':
        return RelationshipTypeList.find((x) => x.value === value)?.label ?? '';
      case 'MatterStepStatus':
        return MatterProcessStepStatusList.find((x) => x.value === value)?.label ?? '';
      case 'Audience':
        return AudienceList.find((x) => x.value === value)?.label ?? '';
      case 'QuestionnaireStatus':
        return QuestionnaireStatusList.find((x) => x.value === value)?.label ?? '';
      case 'CompanyAddressType':
        return CompanyAddressTypeList.find((x) => x.value === value)?.label ?? '';
      case 'ImmigrantStatus':
        return ImmigrantStatusList.find((x) => x.value === value)?.label ?? '';
      case 'FNEducation':
        return FNEducationList.find((x) => x.value === value)?.label ?? '';
      case 'CompanyContactRole':
        if (value === 0) {
          return CompanyContactRoleList.find((x) => x.value === 0)?.label ?? '';
        }
        return CompanyContactRoleList
          .filter((x) => x.value !== 0 && (value & x.value) === x.value)
          .map((x) => x.label)
          .join(', ');
      case 'MatterReceiptStatus':
        return MatterReceiptStatusList.find((x) => x.value === value)?.label ?? '';
      case 'MatterReceiptShipMethod':
        return MatterReceiptShipMethodList.find((x) => x.value === value)?.label ?? '';
      case 'MatterReceiptType':
        return MatterReceiptTypeList.find((x) => x.value === value)?.label ?? '';
      case 'FNDocumentType':
        return FNDocumentTypeList.find((x) => x.value === value)?.label ?? '';
      case 'PartnerCompanyType':
        return CompanyPartnerTypeList.find((x) => x.value === value)?.label ?? '';
      case 'CompanyType':
        return CompanyTypeList.find((x) => x.value === value)?.label ?? '';
      case 'AddressSuiteType':
        return AddressSuiteTypeList.find((x) => x.value === value)?.label ?? '';
      case 'AddressType':
        return AddressTypeList.find((x) => x.value === value)?.label ?? '';
      case 'VisaType':
        return VisaTypeList.find((x) => x.value === value)?.label ?? '';
      case 'VisaCategory':
        return VisaCategoryList.find((x) => x.value === value)?.label ?? '';
      case 'ActiveStatus':
        return ActiveStatusList.find((x) => x.value === value)?.label ?? '';
      case 'MatterEVLStatus':
        return MatterEVLStatusList.find((x) => x.value === value)?.label ?? '';
      case 'MatterDocRequestStatus':
        return MatterDocRequestStatusList.find((x) => x.value === value)?.label ?? '';
      case 'SponsorType':
        return SponsorTypeList.find((x) => x.value === value)?.label ?? '';
      case 'AlertType':
        return AlertTypeList.find((x) => x.value === value)?.label ?? '';
    }
  }
}
